import { Outlet } from "react-router-dom";
import lungs from "../../assets/images/lungs.svg";
import Logo from "../Logo";

function AuthFlowLayout() {
    return (
        <div className="font-open-sans bg-blue-light w-screen h-screen flex flex-col items-center justify-center px-10">
            <div className="w-[1000px] max-w-full flex justify-between items-center shadow-[0px_2px_8px_0px_#366CD680] bg-white rounded-md px-[29px] space-x-20">
                <div className="h-full w-96 flex flex-col space-y-10 pt-12 pb-12">
                    <Logo />
                    <Outlet />
                </div>
                <div className="flex-1">
                    <img src={lungs} alt="Lungs" className="" />
                </div>
            </div>
        </div>
    );
}

export default AuthFlowLayout;
